






































import {Component, Prop, Watch, Provide, Vue} from 'vue-property-decorator'
import {$, Helper} from 'simpli-web-sdk'
import {TypeSms} from '@/model/resource/TypeSms'
import {InputTypeSmsSchema} from '@/schema/resource/TypeSms/InputTypeSmsSchema'

@Component
export default class PersistTypeSmsView extends Vue {
  @Prop() id?: string

  @Provide('validator') validator = this.$validator

  schema = new InputTypeSmsSchema()
  typeSms = new TypeSms()

  async created() {
    await this.populate()
  }

  async populate() {
    const id = Number(this.id) || null

    if (id) {
      await this.typeSms.getTypeSms(id)
    }

    $.await.done('getTypeSms')
  }

  async persist() {
    const isValid = await this.validator.validateAll()

    if (!isValid) {
      Helper.abort('system.error.validation')
    }

    await this.typeSms.persistTypeSms()
    await Helper.successAndPush('system.success.persist', '/type-sms/list')
  }
}
